import React from 'react';
import { CForm, CFormLabel, CFormInput, CButton } from '@coreui/react';
import AsyncSelect from 'react-select/async';
import Select from 'react-select'
import { Link } from 'react-router-dom'

// Компонент для створення плану робіт
const CreateWorkSchedule = (props) => {

   return (
      <CForm onSubmit={props.handleSubmit} className="mb-3">

         <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput1">Контрагент</CFormLabel>
            <AsyncSelect
               cacheOptions
               loadOptions={props.loadOptionsPartners}
               defaultOptions
               value={props.selectedOptionPartner}
               onChange={props.handleChangePartner}
               className="flex-grow-1"
            />
         </div>

         <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput1">Підрозділ</CFormLabel>
            <AsyncSelect
               cacheOptions
               loadOptions={props.loadOptionsFactories}
               defaultOptions
               value={props.selectedOptionFactories}
               onChange={props.handleChangeFactories}
               className="flex-grow-1"
            />
         </div>

         <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput1">Договори</CFormLabel>
            <Select
               cacheOptions
               options={props.agreementsOptions}
               defaultOptions
               value={props.selectedAgreement}
               onChange={props.handleChangeAgreement}
               className="flex-grow-1"
            />
         </div>

         <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput3">Інженери</CFormLabel>
            {/*  селект для інженера */}
            <Select
               // key={props.selectedOptionEngineers?.value}
               key={props.selectedOptionFactories?.value || 'empty'}
               cacheOptions
               options={props.engineers}
               defaultOptions
               value={props.selectedOptionEngineers}
               onChange={props.handleChangeEngineers}
               className="flex-grow-1"
            // id="exampleFormControlInput3"
            />
         </div>
         {/* селект для інженера */}

         <div className="mb-3">
            <CFormLabel htmlFor="exampleFormControlInput2">Опис</CFormLabel>
            <CFormInput
               type="text"
               id="exampleFormControlInput2"
               value={props.description}
               onChange={(e) => props.setDescription(e.target.value)}
               autoComplete="off"
            />
         </div>

         <div className="mb-5">
            <CFormLabel htmlFor="exampleFormControlFile1">Імпорт графіку з Excel</CFormLabel>
            <CFormInput
               type="file"
               id="exampleFormControlFile1"
               onChange={props.handleFileChange}
               ref={props.fileInputRef}
            />
         </div>

         <CButton type="submit" color="success" disabled={props.graficLoad}>
            {props.graficLoad ? "Збереження..." : "Зберегти"}
         </CButton>
         <Link to={props.urlRouter} className="ms-3">
            <CButton type="submit" color="secondary">
               Відміна
            </CButton>
         </Link>
      </CForm>
   );
};

export default CreateWorkSchedule;